import getTarget from 'javascripts/utils/get-target';

// Glossary
export default class GlossaryList {
  constructor($glossaryList) {
    this.$glossaryList = $glossaryList;

    this.$toTops = this.$glossaryList.querySelectorAll('.glossary-list__to-top');
    this.$glossaryTablist = this.$glossaryList.querySelector('.tab-bar__list');

    this.clickedTabId = false;

    this.$glossaryTablist.addEventListener('click', this.onItemClick.bind(this));
    window.addEventListener('hashchange', this.onHashchange.bind(this));

    this.$toTops.forEach(($toTop) => {
      $toTop.addEventListener('click', this.onTotopClick.bind(this));
    });
  }

  onHashchange() {
    this.openByHash();
  }

  openByHash() {
    if (window.location.hash) {
      const anchorTarget = window.location.hash.substring(1);
      setTimeout(() => {
        document.getElementById(anchorTarget).focus();
        document.getElementById(anchorTarget).classList.add('focus-visible', 'focus-within');
      });
    }
  }

  onTotopClick() {
    if (this.clickedTabId) {
      setTimeout(() => {
        document.getElementById(this.clickedTabId).focus();
        document.getElementById(this.clickedTabId).classList.add('focus-visible', 'focus-within');
      });
    }
  }

  onItemClick(event) {
    const $target = getTarget(event.target, '.tab-bar__item');

    if ($target) {
      this.clickedTabId = $target.getAttribute('id');
      this.openByHash();
    }
  }
}

document.querySelectorAll('.glossary-list').forEach($glossaryList => new GlossaryList($glossaryList));
